<template>
  <div class="collect">
    <div class="collect-i" v-for="(item, index) in collectList" :key="index">
      <img :src="item.projectImg" alt="" />
      <div
        style="
          height: 17px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 18px;
          padding-left:10px;
        "
      >
        {{ item.name }}
      </div>
      <div class="collect-i-txt" style="">{{ item.remark }}</div>
    </div>
  </div>
</template>

<script>
import areasData from "@/assets/areas.json";

export default {
  name: "collect",
  data() {
    return {
      tabIndex: 1,
      collectList: [],
    };
  },
  methods: {
    btnFn(s) {
      this.tabIndex = s;
    },
  },
  created() {
    this.$axios
      .get("/v1/cloud/user/me/collection", {})
      .then(({ data }) => {
        if (data) {
          this.collectList = data;
        }
        console.log(data);
      })
      .catch((error) => {
        var err = error.response;
        if (err.status == 400) {
          this.$Message.error(err.data.message);
        }
        if (err.status == 401) {
          this.$router.push({ name: "login" });
        }
      });
  },
  mounted() {},
};
</script>

<style scoped lang="less">
a {
  text-decoration: none;
}
li {
  list-style: none;
}
input {
  outline: none;
  border: none;
  background: rgba(0, 0, 0, 0);
}
.collect {
  width: 950px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  .collect-i {
    width: 303px;
    height: 342px;
    background: rgba(255, 255, 255, 1);
    margin-bottom: 30px;
    img {
      display: block;
      width: 303px;
      height: 200px;
      margin-bottom: 20px;
    }
    .collect-i-txt {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #888888;
      line-height: 25px;
      margin: 10px 0;
      padding: 0 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
}
</style>